"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockPolledLiquityStore = void 0;
const lib_base_1 = require("@liquity/lib-base");
const _utils_1 = require("./_utils");
const EthersLiquityConnection_1 = require("./EthersLiquityConnection");
/**
 * Ethers-based {@link @liquity/lib-base#LiquityStore} that updates state whenever there's a new
 * block.
 *
 * @public
 */
class BlockPolledLiquityStore extends lib_base_1.LiquityStore {
    constructor(readable) {
        super();
        this.connection = readable.connection;
        this._readable = readable;
        this._provider = EthersLiquityConnection_1._getProvider(readable.connection);
    }
    async _get(blockTag) {
        const { userAddress } = this.connection;
        const whitelistedCollaterals = await this._readable.getWhitelistedCollaterals({ blockTag });
        const collPrices = {};
        const { blockTimestamp } = await _utils_1.promiseAllValues({ blockTimestamp: this._readable._getBlockTimestamp(blockTag) });
        // console.log('blockTimestamp', blockTimestamp);
        const { _feesFactory, numberOfTroves, yusdInStabilityPool, totalStakedYETI, totalSYETISupply, remainingStabilityPoolYETIReward, totalRedistributed, total, accountBalance, sYETIBalance, yusdBalance, yetiBalance, stabilityDeposit, farm, farmYETI, veYETIStaked, yetiStake, collateralSurplusBalance, troveBeforeRedistribution, price, tokenBalances, lpTokenBalance, icr, vcValue, recoveryRatios, safetyRatios, decimals, YETIPrice, YUSDPrice, globalBoostFactor, decayedBoost } = await _utils_1.promiseAllValues({
            _feesFactory: this._readable._getFeesFactory({ blockTag }),
            numberOfTroves: this._readable.getNumberOfTroves({ blockTag }),
            yusdInStabilityPool: this._readable.getYUSDInStabilityPool({ blockTag }),
            totalStakedYETI: this._readable.getTotalStakedYETI({ blockTag }),
            totalSYETISupply: this._readable.getTotalSYETISupply({ blockTag }),
            remainingStabilityPoolYETIReward: this._readable.getRemainingStabilityPoolYETIReward({
                blockTag
            }),
            totalRedistributed: this._readable.getTotalRedistributed({ blockTag }),
            total: this._readable.getTotal({ blockTag }),
            accountBalance: this._provider.getBalance(userAddress !== null && userAddress !== void 0 ? userAddress : '0', blockTag).then(_utils_1.decimalify),
            sYETIBalance: this._readable.getSYETIBalance(userAddress, { blockTag }),
            yusdBalance: this._readable.getYUSDBalance(userAddress, { blockTag }),
            yetiBalance: this._readable.getYETIBalance(userAddress, { blockTag }),
            stabilityDeposit: this._readable.getStabilityDeposit(userAddress, { blockTag }),
            farm: this._readable.getFarm(userAddress, { blockTag }),
            farmYETI: this._readable.getFarmYETI(userAddress, { blockTag }),
            veYETIStaked: this._readable.getVEYETIStake(userAddress, { blockTag }),
            yetiStake: this._readable.getYETIStake(userAddress, { blockTag }),
            collateralSurplusBalance: this._readable.getCollateralSurplusBalancee({ blockTag }),
            troveBeforeRedistribution: this._readable.getTroveBeforeRedistribution(userAddress, {
                blockTag
            }),
            price: this._readable.getCollPrices(whitelistedCollaterals),
            tokenBalances: this._readable.getBalances(whitelistedCollaterals),
            lpTokenBalance: this._readable.getLPBalances(userAddress, { blockTag }),
            icr: this._readable.getICR(userAddress, { blockTag }),
            vcValue: this._readable.getVcValue(userAddress, { blockTag }),
            safetyRatios: this._readable.getSafetyRatios(whitelistedCollaterals),
            recoveryRatios: this._readable.getRecoveryRatios(whitelistedCollaterals),
            decimals: this._readable.getDecimals(whitelistedCollaterals),
            YETIPrice: this._readable.getYETIPrice(),
            YUSDPrice: this._readable.getYUSDPrice(),
            globalBoostFactor: this._readable.getGlobalBoostFactor(),
            decayedBoost: this._readable.getDecayedBoost(userAddress)
        });
        // console.log('_feesFactory', _feesFactory)
        // const { calculateRemainingYETI } = await promiseAllValues({ calculateRemainingYETI: this._readable._getRemainingLiquidityMiningYETIRewardCalculator({
        //   blockTag
        // }) })
        // console.log('calculateRemainingYETI', calculateRemainingYETI)
        // const { pngCalculateRemainingYETI } = await promiseAllValues({ pngCalculateRemainingYETI: this._readable._pngGetRemainingLiquidityMiningYETIRewardCalculator({
        //   blockTag
        // }) })
        // console.log('pngCalculateRemainingYETI', pngCalculateRemainingYETI)
        // const { tjCalculateRemainingYETI } = await promiseAllValues({ tjCalculateRemainingYETI: this._readable._tjGetRemainingLiquidityMiningYETIRewardCalculator({
        //   blockTag
        // }) })
        // console.log('tjCalculateRemainingYETI', tjCalculateRemainingYETI)
        // const { numberOfTroves } = await promiseAllValues({ numberOfTroves: this._readable.getNumberOfTroves({ blockTag }) })
        // console.log('numberoftroves', numberOfTroves)
        // const { yusdInStabilityPool } = 
        // console.log('yusdInStabilityPool', yusdInStabilityPool)
        // const { totalStakedYETI } = await promiseAllValues({ totalStakedYETI: this._readable.getTotalStakedYETI({ blockTag }) })
        // console.log('totalStakedYETI', totalStakedYETI)    
        // const { totalSYETISupply } = await promiseAllValues({ totalSYETISupply: this._readable.getTotalSYETISupply({ blockTag }) })
        // console.log('totalSYETISupply', totalSYETISupply)   
        // const { totalStakedUniTokens } = await promiseAllValues({ totalStakedUniTokens: this._readable.getTotalStakedUniTokens({ blockTag }) })
        // console.log('totalStakedUniTokens', totalStakedUniTokens)
        // const { pngTotalStakedUniTokens } = await promiseAllValues({ pngTotalStakedUniTokens: this._readable.pngGetTotalStakedUniTokens({ blockTag }) })
        // console.log('pngTotalStakedUniTokens', pngTotalStakedUniTokens)
        // const { tjTotalStakedUniTokens } = await promiseAllValues({ tjTotalStakedUniTokens: this._readable.tjGetTotalStakedUniTokens({ blockTag }) })
        // console.log('tjTotalStakedUniTokens', tjTotalStakedUniTokens)
        // const { remainingStabilityPoolYETIReward } = await promiseAllValues({ remainingStabilityPoolYETIReward: this._readable.getRemainingStabilityPoolYETIReward({
        //   blockTag
        // }) })
        // console.log('remainingStabilityPoolYETIReward', remainingStabilityPoolYETIReward)
        // const { frontend } = await promiseAllValues({ frontend: frontendTag
        //   ? this._readable.getFrontendStatus(frontendTag, { blockTag })
        //   : { status: "unregistered" as const } })
        // console.log('frontend', frontend)
        //THESE FAIL: FIX
        //total redistributed loops through whitelisted colls is cause of error
        // const { totalRedistributed } = await promiseAllValues({totalRedistributed: this._readable.getTotalRedistributed({ blockTag })})
        // console.log('totalRedistributed', totalRedistributed)
        // const { total } = await promiseAllValues({total: this._readable.getTotal({ blockTag })})
        // console.log('total', total)
        // const { _riskiestTroveBeforeRedistribution } = await promiseAllValues({ _riskiestTroveBeforeRedistribution: this._readable.getRiskiestTrove({ blockTag }) })
        // console.log('_riskiestTroveBeforeRedistribution', _riskiestTroveBeforeRedistribution)
        //USER ADDRESS STUFF
        // const { accountBalance } = await promiseAllValues({accountBalance: this._provider.getBalance(userAddress ?? '0', blockTag).then(decimalify)})
        // console.log('accountBalance', accountBalance)
        // const tokenBalances: TroveMappings = {}
        // const price: TroveMappings = {}
        // const balance_promises = whitelistedColls.map(this._readable.getBalanceERC20)
        // const prices_promises = whitelistedColls.map((coll) => {this._readable.getCollPrice(coll)})
        // for (let coll = 0; coll < whitelistedColls.length; coll++) {
        //   // console.log('whitelistedColls[coll]', whitelistedColls[coll])
        //   const { tokenBalance } = await promiseAllValues({tokenBalance: this._readable.\(whitelistedColls[coll])})
        //   // console.log('tokenBalance', tokenBalance)
        //   tokenBalances[whitelistedColls[coll]] = tokenBalance
        //   // console.log('tokenBalances', tokenBalances)
        //   const { collPrice } = await promiseAllValues({collPrice: this._readable.getCollPrice(whitelistedColls[coll])})
        //   // console.log('collPrice', collPrice)
        //   price[whitelistedColls[coll]] = collPrice
        //   // console.log('price', price)
        // }
        // console.log('prices', price)
        // console.log('tokenBalances', tokenBalances)  
        // const { sYETIBalance } = await promiseAllValues({sYETIBalance: this._readable.getSYETIBalance(userAddress, { blockTag })})
        // console.log('sYETIBalance', sYETIBalance)  
        // const { yusdBalance } = await promiseAllValues({yusdBalance: this._readable.getYUSDBalance(userAddress, { blockTag })})
        // console.log('yusdBalance', yusdBalance)
        // const { yetiBalance } = await promiseAllValues({yetiBalance: this._readable.getYETIBalance(userAddress, { blockTag })})
        // console.log('yetiBalance', yetiBalance)
        // const { uniTokenBalance } = await promiseAllValues({uniTokenBalance: this._readable.getUniTokenBalance(userAddress, { blockTag })})
        // // console.log('uniTokenBalance', uniTokenBalance)
        // const { pngTokenBalance } = await promiseAllValues({pngTokenBalance: this._readable.pngGetUniTokenBalance(userAddress, { blockTag })})
        // // console.log('pngTokenBalance', pngTokenBalance)
        // const { tjTokenBalance } = await promiseAllValues({tjTokenBalance: this._readable.tjGetUniTokenBalance(userAddress, { blockTag })})
        // // console.log('tjTokenBalance', tjTokenBalance)
        // const { uniTokenAllowance } = await promiseAllValues({uniTokenAllowance: this._readable.getUniTokenAllowance(userAddress, { blockTag })})
        // // console.log('uniTokenAllowance', uniTokenAllowance)
        // const { pngTokenAllowance } = await promiseAllValues({pngTokenAllowance: this._readable.pngGetUniTokenAllowance(userAddress, { blockTag })})
        // // console.log('pngTokenAllowance', pngTokenAllowance)
        // const { tjTokenAllowance } = await promiseAllValues({tjTokenAllowance: this._readable.tjGetUniTokenAllowance(userAddress, {
        //   blockTag
        // })})
        // // console.log('tjTokenAllowance', tjTokenAllowance)
        // const { liquidityMiningStake } = await promiseAllValues({liquidityMiningStake: this._readable.getLiquidityMiningStake(userAddress, { blockTag })})
        // // console.log('liquidityMiningStake', liquidityMiningStake)
        // const { pngLiquidityMiningStake } = await promiseAllValues({pngLiquidityMiningStake: this._readable.pngGetLiquidityMiningStake(userAddress, {
        //   blockTag
        // })})
        // // console.log('pngLiquidityMiningStake', pngLiquidityMiningStake)
        // const { tjLiquidityMiningStake } = await promiseAllValues({tjLiquidityMiningStake: this._readable.tjGetLiquidityMiningStake(userAddress, {
        //   blockTag
        // })})
        // // console.log('tjLiquidityMiningStake', tjLiquidityMiningStake)
        // const { liquidityMiningYETIReward } = await promiseAllValues({liquidityMiningYETIReward: this._readable.getLiquidityMiningYETIReward(userAddress, {
        //   blockTag
        // })})
        // // console.log('liquidityMiningYETIReward', liquidityMiningYETIReward)
        // const { pngLiquidityMiningYETIReward } = await promiseAllValues({pngLiquidityMiningYETIReward: this._readable.pngGetLiquidityMiningYETIReward(
        //   userAddress,
        //   {
        //     blockTag
        //   }
        // )})
        // // console.log('pngLiquidityMiningYETIReward', pngLiquidityMiningYETIReward)
        // const { tjLiquidityMiningYETIReward } = await promiseAllValues({tjLiquidityMiningYETIReward: this._readable.tjGetLiquidityMiningYETIReward(userAddress, {
        //   blockTag
        // })})
        // console.log('tjLiquidityMiningYETIReward', tjLiquidityMiningYETIReward)
        // const { stabilityDeposit } = await promiseAllValues({stabilityDeposit: this._readable.getStabilityDeposit(userAddress, { blockTag })})
        // console.log('stabilityDeposit', stabilityDeposit)
        // const { yetiStake } = await promiseAllValues({yetiStake: this._readable.getYETIStake(userAddress, { blockTag })})
        // console.log('yetiStake', yetiStake)
        //const { ownFrontend } = await promiseAllValues({ownFrontend: this._readable.getFrontendStatus(userAddress, { blockTag })})
        // console.log('ownFrontend', ownFrontend)
        // const { collateralSurplusBalance } = await promiseAllValues({collateralSurplusBalance: this._readable.getCollateralSurplusBalancee({blockTag})})
        // console.log('collateralSurplusBalance', collateralSurplusBalance)
        // const { troveBeforeRedistribution } = await promiseAllValues({troveBeforeRedistribution: this._readable.getTroveBeforeRedistribution(userAddress, {
        //   blockTag
        // })})
        // console.log('troveBeforeRedistribution', troveBeforeRedistribution)
        //THESE FAIL: FIX (collsurplus balance needs coll address)
        // const {
        //   ...baseState
        // } = await promiseAllValues({
        //   ...(userAddress
        //     ? {
        //       }
        //     : {
        //         accountBalance: Decimal.ZERO,
        //         yusdBalance: Decimal.ZERO,
        //         yetiBalance: Decimal.ZERO,
        //         uniTokenBalance: Decimal.ZERO,
        //         pngTokenBalance: Decimal.ZERO,
        //         tjTokenBalance: Decimal.ZERO,
        //         uniTokenAllowance: Decimal.ZERO,
        //         pngTokenAllowance: Decimal.ZERO,
        //         tjTokenAllowance: Decimal.ZERO,
        //         liquidityMiningStake: Decimal.ZERO,
        //         pngLiquidityMiningStake: Decimal.ZERO,
        //         tjLiquidityMiningStake: Decimal.ZERO,
        //         liquidityMiningYETIReward: Decimal.ZERO,
        //         pngLiquidityMiningYETIReward: Decimal.ZERO,
        //         tjLiquidityMiningYETIReward: Decimal.ZERO,
        //         collateralSurplusBalance: Decimal.ZERO,
        //         troveBeforeRedistribution: new TroveWithPendingRedistribution(
        //           AddressZero,
        //           "nonExistent"
        //         ),
        //         stabilityDeposit: new StabilityDeposit(
        //           Decimal.ZERO,
        //           Decimal.ZERO,
        //           {},
        //           Decimal.ZERO,
        //           AddressZero
        //         ),
        //         yetiStake: new YETIStake(),
        //         ownFrontend: { status: "unregistered" as const }
        //       })
        // });
        // console.log('success!')
        // Removed
        //remainingLiquidityMiningYETIReward: calculateRemainingYETI(blockTimestamp),
        return [
            {
                price,
                numberOfTroves,
                totalRedistributed,
                total,
                yusdInStabilityPool,
                totalStakedYETI,
                totalSYETISupply,
                remainingStabilityPoolYETIReward,
                accountBalance,
                tokenBalances,
                lpTokenBalance,
                sYETIBalance,
                yusdBalance,
                yetiBalance,
                collateralSurplusBalance,
                troveBeforeRedistribution,
                stabilityDeposit,
                farm,
                farmYETI,
                veYETIStaked,
                yetiStake,
                _feesInNormalMode: _feesFactory(blockTimestamp, false),
                whitelistedCollaterals,
                icr,
                vcValue,
                safetyRatios,
                recoveryRatios,
                decimals,
                YETIPrice,
                YUSDPrice,
                globalBoostFactor,
                decayedBoost
            },
            {
                blockTag,
                blockTimestamp,
                _feesFactory
            }
        ];
    }
    /** @internal @override */
    _doStart() {
        // console.log('_loaded', this._loaded)
        // console.log('_load', this._load)
        this._get().then(state => {
            // console.log("get hit")
            if (!this._loaded) {
                this._load(...state);
                // console.log("get loaded")
            }
        });
        const blockListener = async (blockTag) => {
            // console.log("NEW LISTEN")
            const state = await this._get(blockTag);
            // console.log('_loaded in block listener', this._loaded)
            if (this._loaded) {
                this._update(...state);
                // console.log("boom")
            }
            else {
                this._load(...state);
            }
        };
        this._provider.on("block", blockListener);
        return () => {
            this._provider.off("block", blockListener);
        };
    }
    /** @internal @override */
    _reduceExtra(oldState, stateUpdate) {
        var _a, _b, _c;
        return {
            blockTag: (_a = stateUpdate.blockTag) !== null && _a !== void 0 ? _a : oldState.blockTag,
            blockTimestamp: (_b = stateUpdate.blockTimestamp) !== null && _b !== void 0 ? _b : oldState.blockTimestamp,
            _feesFactory: (_c = stateUpdate._feesFactory) !== null && _c !== void 0 ? _c : oldState._feesFactory
        };
    }
}
exports.BlockPolledLiquityStore = BlockPolledLiquityStore;
//# sourceMappingURL=BlockPolledLiquityStore.js.map